import { SetApplicationFlag } from '@/apis/family_application/requests'
import { SubmitTaxComissionUserConfirmation, UpdateIncomeDetails } from '@/app-storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/app-storage/program_settings/programSettingsSlice.ts'
import { useAppAlert } from '@/app/AppAlertProvider'
import { static_errors } from '@/app/common/constants'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { SubmitButton } from '@/app/pages/family_application/student_details/shared/submit-button'
import { AppRoutePaths } from '@/routing/route_paths'
import { AppDispatch, RootState } from '@/storage/store'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

export const TaxCommissionConfirmationPage = () => {
  const navigateTo = useNavigate()
  const { t: translate } = useTranslation()
  const {
    data: applicationData,
    tax_commission_response,
    request,
  } = useSelector((state: RootState) => state.FamilyApplication)
  const Dispatch = useDispatch<AppDispatch>()
  const ProgramId = useSelector(selectProgramID)
  const { fireAlert } = useAppAlert()

  async function submitCorrectInformation() {
    await Dispatch(UpdateIncomeDetails({
      program_id: ProgramId,
      skip_income_verification: false
    }))
    const resultAction = await Dispatch(
      SubmitTaxComissionUserConfirmation({
        tax_commission_attested_data_by_applicant: 1,
        application_id: applicationData?.application_id ?? 0,
        program_id: ProgramId,
        activity_log_ids: tax_commission_response.map(
          (item) => item.activity_log_id
        ),
      })
    )
    navigateTo(AppRoutePaths.family_application.income_verification.completed)
    return
    if (SubmitTaxComissionUserConfirmation.fulfilled.match(resultAction)) {
      navigateTo(AppRoutePaths.family_application.income_verification.completed)
    } else {
      await SetApplicationFlag({
        application_id: applicationData?.application_id ?? 0,
        flag: 'tax_commission_error',
        global_application_step_code: 'tax_commission',
      })

      fireAlert({
        variant: 'error',
        message:
          resultAction.payload?.message ??
          static_errors.unexpected_contact_support,
      }).then(() => {

        navigateTo(
          AppRoutePaths.family_application.income_verification
            .document_instructions
        )
      })
    }
  }

  const submitIncorrectInformation = async () => {
    const setFlagAction = await SetApplicationFlag({
      application_id: applicationData?.application_id ?? 0,
      flag: 'tax_commission_applicant_attested_incorrect_data',
      global_application_step_code: 'tax_commission',
    })

    if (setFlagAction?.error?.message) {
      fireAlert({
        variant: 'error',
        message: setFlagAction.error?.message,
      })
      return
    }
    if (tax_commission_response != undefined) {
      Dispatch(
        SubmitTaxComissionUserConfirmation({
          tax_commission_attested_data_by_applicant: 0,
          application_id: applicationData?.application_id ?? 0,
          program_id: ProgramId,
          activity_log_ids: tax_commission_response.map(
            (item) => item.activity_log_id
          ),
        })
      )
    }
    navigateToManualIncome()
  }

  const navigateToManualIncome = () => {
    navigateTo(
      AppRoutePaths.family_application.income_verification.document_instructions
    )
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('tax_commission_verification')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <h2 className="text-xl font-medium text-gray-900 mb-10 sm:mb-5 text-center">
          {translate('tax_commission_confirmation')}
        </h2>
        <div className="my-10">
          {tax_commission_response?.map((item) => {
            return (
              <div>
                <div className="mb-3">
                  <p className="font-medium">
                    {translate('feed_adjusted_gross_income')}:
                  </p>
                  <p className="mb-1 text-gray-700 text-sm">
                    {item?.FedAdjustedGrossIncome.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-medium">{translate('income_tax_year')}:</p>
                  <p className="mb-1 text-gray-700 text-sm">
                    {item?.IncomeTaxYear}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-medium">
                    {translate('number_of_dependents')}:
                  </p>
                  <p className="mb-1 text-gray-700 text-sm">
                    {item?.NumberofDependents}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-medium">{translate('filing')}:</p>
                  <p className="mb-1 text-gray-700 text-sm">{item?.Filing}</p>
                </div>
              </div>
            )
          })}
          <p className="text-lg text-gray-700 mt-10">
            {translate("accept_or_reject_income")}
          </p>
        </div>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <SubmitButton
          status={request.status}
          onClick={submitCorrectInformation}
          buttonTxt={translate('accept')}
          aria-label={translate('accept')}
        />
      </FamilyWizardLayout.ActionBar>
      <FamilyWizardLayout.ActionBar>
        <SubmitButton
          status={request.status}
          style={{ marginTop: '-30px' }}
          onClick={submitIncorrectInformation}
          buttonTxt={translate('reject')}
          aria-label={translate('reject')}
        />
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
